import * as LoyaltyTileActions from '../actions/actions-loyalty-tile';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
  isRequested: boolean;
  isLoading: boolean;
  loadingError: string;
}

const initialState: State = {
  isRequested: false,
  isLoading: false,
  loadingError: ''
};

const loyaltyTileReducer = createReducer(
  initialState,
  on(LoyaltyTileActions.loyaltyTileInit, (state, { isRequested }) => ({
    ...state,
    isRequested
  })),
  on(LoyaltyTileActions.loyaltyTileRequest, state => ({
    ...state,
    isLoading: true,
    loadingError: ''
  })),
  on(LoyaltyTileActions.loyaltyTileRequestSuccess, (state, { isRequested }) => ({
    ...state,
    isRequested,
    isLoading: false,
    loadingError: ''
  })),
  on(LoyaltyTileActions.loyaltyTileRequestError, (state, { error }) => ({
    ...state,
    isRequested: false,
    isLoading: false,
    loadingError: error
  })),
  on(LoyaltyTileActions.loyaltyTileApprove, state => ({
    ...state,
    isLoading: true,
    loadingError: ''
  })),
  on(LoyaltyTileActions.loyaltyTileApproveSuccess, state => ({
    ...state,
    isLoading: false,
    loadingError: ''
  })),
  on(LoyaltyTileActions.loyaltyTileApproveError, (state, { error }) => ({
    ...state,
    isLoading: false,
    loadingError: error
  }))
);

/* eslint-disable */
export function reducer(state: State | undefined, action: Action) {
  return loyaltyTileReducer(state, action);
}
